/* eslint-disable react/no-array-index-key */
import React, {PureComponent} from 'react';
import {CarModelModel} from '../../api/core/core.types';
import {
  DatedRatePeriod,
  GroupBy,
  RatesGroupedByRentalDays,
  StopSellPeriod,
  StopSellRuleType
} from '../../api/pricing/pricing.types';
import {RateSquare, RateSquareInfo} from './RateSquare';
import dayjs, {Dayjs} from 'dayjs';
import {isSameOrBefore} from '../../helpers/date.helper';

interface RatesTableElementProps {
  groupedBy: GroupBy;
  carModel?: CarModelModel;
  rentalDays?: number;
  ratePeriods: RatesGroupedByRentalDays[];
  startingDate: string;
  endDate: string;
  largestPerDay: number;
  smallestPerDay: number;
  deskCode: string | undefined;
  brokerRateCode: string | undefined;
  onRateSquareClick: (info: RateSquareInfo) => void;
}

export class RatesTableElement extends PureComponent<RatesTableElementProps> {

  getStopSellsForDate = (date: Dayjs, ratePeriods: RatesGroupedByRentalDays) => {
    const stopSellsForDate: StopSellPeriod[] = [];

    if (!ratePeriods.stopSells || !ratePeriods.stopSells.length) {
      return stopSellsForDate;
    }

    ratePeriods.stopSells.forEach((ss: StopSellPeriod) => {
      if (isSameOrBefore(dayjs( ss.startDateTime), date) && isSameOrBefore(date, dayjs(ss.endDateTime))) {
        if (ss.ruleType === StopSellRuleType.BLOCK_SHORT_RENTALS) {
          if (ratePeriods.rentalDays <= ss.rentalDays) {
            stopSellsForDate.push(ss);
          }
        } else {
          stopSellsForDate.push(ss);
        }
      }
    });

    return stopSellsForDate;
  };

  getDailyRatesRow = (ratePeriods: RatesGroupedByRentalDays) => {
    const rateSquareList: any[] = [];
    let date = dayjs(this.props.startingDate);

    let squareNumber = 0;
    ratePeriods.datedRatePeriods.forEach((datedPeriod: DatedRatePeriod) => {
      while (isSameOrBefore(date, dayjs(datedPeriod.endDate)) && isSameOrBefore(date, dayjs(this.props.endDate))) {

        if (date.isBefore(dayjs(datedPeriod.startDate))) {
          rateSquareList.push((
            <RateSquare
              onRateSquareClick={(info: RateSquareInfo) => this.props.onRateSquareClick(info)}
              id={`rate-square-${this.props.rentalDays ? this.props.rentalDays : ratePeriods.rentalDays}-${this.props.carModel ? this.props.carModel.id : ratePeriods.carModelName}-${this.props.carModel ? this.props.carModel.acrissCode : ratePeriods.carModelAcrissCode}-${squareNumber}`}
              isEmpty
              stopSells={[]}
              date={date.toString()}
              largestPerDay={this.props.largestPerDay}
              smallestPerDay={this.props.smallestPerDay}
              rateInfo={datedPeriod}
            />
          ));
          squareNumber++;

        } else {
          rateSquareList.push((
            <RateSquare
              onRateSquareClick={(info: RateSquareInfo) => this.props.onRateSquareClick(info)}
              id={`rate-square-${this.props.rentalDays ? this.props.rentalDays : ratePeriods.rentalDays}-${this.props.carModel ? this.props.carModel.id : ratePeriods.carModelName}-${this.props.carModel ? this.props.carModel.acrissCode : ratePeriods.carModelAcrissCode}-${squareNumber}`}
              date={date.toString()}
              stopSells={this.getStopSellsForDate(date, ratePeriods)}
              largestPerDay={this.props.largestPerDay}
              smallestPerDay={this.props.smallestPerDay}
              rateInfo={datedPeriod}
            />
          ));
          squareNumber++;
        }

        date = date.add(1, 'd');
      }
    });

    while (date.isBefore(dayjs(dayjs(this.props.endDate)))) {
      rateSquareList.push((
        <RateSquare
          onRateSquareClick={(info: RateSquareInfo) => this.props.onRateSquareClick(info)}
          id={`rate-square-${this.props.rentalDays ? this.props.rentalDays : ratePeriods.rentalDays}-${this.props.carModel ? this.props.carModel.id : ratePeriods.carModelName}-${this.props.carModel ? this.props.carModel.acrissCode : ratePeriods.carModelAcrissCode}-${squareNumber}`}
          stopSells={[]}
          isEmpty
          date={date.toString()}
          largestPerDay={this.props.largestPerDay}
          smallestPerDay={this.props.smallestPerDay}
        />
      ));
      squareNumber++;

      date = date.add(1, 'd');
    }

    let rowKey: number | string = 'r';
    if (ratePeriods.rentalDays) rowKey = ratePeriods.rentalDays;
    else if (ratePeriods.carModelAcrissCode) rowKey = ratePeriods.carModelAcrissCode;

    return (
      <tr>
        <td className="pr-1">
          {this.props.groupedBy === GroupBy.CAR_MODEL ? ratePeriods.rentalDays : ratePeriods.carModelAcrissCode}
        </td>
        {rateSquareList.map((rateSquare, index) => <td key={`${rowKey}${index}`}>{rateSquare}</td>)}
      </tr>
    );
  };

  render() {
    return (
      <>
        <div className="rates-overview-table-element">
          <div className="pt-1 pb-1 ml-2 mr-2 d-flex">
            <div className="column pr-2 rates-overview-column-first ">
              <label>{this.props.groupedBy === GroupBy.CAR_MODEL && this.props.carModel ? this.props.carModel.acrissCode : ' '}</label>
              <div
                className="table-text">{this.props.groupedBy === GroupBy.CAR_MODEL && this.props.carModel ? this.props.carModel.name : ' '}</div>
            </div>
            <table>
              <tbody>
              {this.props.ratePeriods.map((ratePeriod: RatesGroupedByRentalDays) => <>{this.getDailyRatesRow(ratePeriod)}</>)}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

}
